import { useState } from 'react';

import EditIcon from '@/components/common/OptionButton/icons/Edit/EditIcon';
import OptionButton from '@/components/common/OptionButton/OptionButton';
import { useSelectedLines } 
  from '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/linesSelectionObservable';
import { useSelectedVariableLines } 
  from '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/variableLinesSelectionObservable';
import ManageBundlesModal from './ManageBundlesModal';

export default function ManageBundlesContainer() {
  const [isOpenManageBundlesModal, setIsOpenManageBundlesModal] =
    useState(false);
  const selectedLineRows = useSelectedLines();
  const selectedVariableLineRows = useSelectedVariableLines();

  const handleOnClick = () => {
    setIsOpenManageBundlesModal(true);
  };

  if(!selectedLineRows?.length && !selectedVariableLineRows?.length) {
    return null;
  }

  return (
    <>
      {isOpenManageBundlesModal && (
        <ManageBundlesModal
          onClose={() => setIsOpenManageBundlesModal(false)}
        />
      )}

      <OptionButton onClick={handleOnClick} Icon={<EditIcon />}>
        Manage Bundles
      </OptionButton>
    </>
  );
}
